import axios from "axios";
import React, { useState } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PSGLOGO from "../Assets/Images/PSG HOSPITALS LOGO.jpg";
const baseurl = `https://hsissmart.psghospitals.com/ps2/api/feedback`;
// import "./Login.css";
const Login = () => {
  const [mobile, setMobile] = useState("");
  const [opCode, setOpCode] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [otpStatus, setOtpStatus] = useState(false);
  const [loading, setLoading] = useState(false); // New loading state
  const navigate = useNavigate();

  const validate = () => {
    let tempErrors = {};
    if (!/^\d{10}$/.test(mobile)) {
      tempErrors.mobile = "Please enter a valid 10-digit mobile number.";
    }
    if (opCode.length < 9) {
      tempErrors.opCode = "OpCode must be at least 9 characters long.";
    }
    if (otp.length === 0 && otpStatus) {
      tempErrors.otp = "OTP is required.";
    }
    return tempErrors;
  };

  const handleSendOtp = async (event) => {
    event.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      setLoading(true); // Set loading to true when starting OTP request
      try {
        const response = await axios.post(
          `${baseurl}/sendotp`, // Assuming this endpoint exists
          {
            mobileNo: mobile,
            opCode: opCode,
          },
          {
            headers: {
              "Access-Control-Allow-Origin": "*", // This is typically set on the server side
              "Content-Type": "application/json", // Set any other headers you need
              // Add any other custom headers here
            },
          }
        );
        if (response.status === 200) {
          setOtpStatus(true);
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000); // Hide alert after 3 seconds
        }
      } catch (err) {
        console.error(err);
        setErrors({ ...errors, otp: "Failed to send OTP. Please try again." });
      } finally {
        setLoading(false); // Set loading to false after request completes
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0 && otpStatus) {
      try {
        const transactionResponse = await axios.post(
          `${baseurl}/opcode/tranctionlist`,
          { mobileNo: mobile, otpCode: otp, opCode: opCode },
          {
            headers: {
              "Access-Control-Allow-Origin": "*", // This is typically set on the server side
              "Content-Type": "application/json", // Set any other headers you need
              // Add any other custom headers here
            },
          }
        );
        const transactionData = transactionResponse.data;
        console.log(transactionResponse);
        navigate("/home", { state: { transactionData } });
      } catch (err) {
        console.error(err);
        setErrors({
          ...errors,
          otp: "Failed to verify OTP. Please try again.",
        });
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light full-page-background">
      <Form className="p-4 bg-white rounded shadow" style={{ width: "400px" }}>
        {/* Top Logo */}
        <div className="text-center mb-4">
          <img
            src={PSGLOGO} // Replace with your logo path
            alt="Logo"
            style={{ width: "100px", height: "auto" }} // Adjust the size as needed
          />
        </div>

        <h2 className="text-center text-primary mb-4">Patient Prescription</h2>

        {showAlert && <Alert variant="success">OTP Sent Successfully!</Alert>}

        {/* Mobile */}
        <Form.Group className="mb-3" controlId="formMobile">
          <Form.Label>Mobile Number</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter mobile number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            isInvalid={!!errors.mobile}
            maxLength={10}
          />
          <Form.Control.Feedback type="invalid">
            {errors.mobile}
          </Form.Control.Feedback>
        </Form.Group>

        {/* OPCode */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <Form.Group className="mb-3" controlId="formOpCode">
            <Form.Label>Patient OPCode</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter OPCode"
              value={opCode}
              onChange={(e) => {
                const value = e.target.value;
                const capitalizedValue =
                  value.charAt(0).toUpperCase() + value.slice(1);
                setOpCode(capitalizedValue);
              }}
              isInvalid={!!errors.opCode}
            />
            <Form.Control.Feedback type="invalid">
              {errors.opCode}
            </Form.Control.Feedback>
          </Form.Group>
          {/* Send OTP Button */}
          <div
            style={{
              height: "30px",
              width: "50%",
              marginTop: "12px",
              marginLeft: "10px",
            }}
          >
            <Button
              variant="primary"
              onClick={handleSendOtp}
              disabled={loading} // Disable button when loading
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Send OTP"}
            </Button>
          </div>
        </div>

        {/* OTP */}
        <Form.Group className="mb-3" controlId="formOtp">
          <Form.Label>OTP</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            isInvalid={!!errors.otp}
          />
          <Form.Control.Feedback type="invalid">
            {errors.otp}
          </Form.Control.Feedback>
        </Form.Group>

        <Button
          variant="primary"
          className="w-100"
          disabled={!otpStatus || loading} // Disable button when OTP not sent or loading
          onClick={handleLogin}
        >
          {loading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            "View Prescription"
          )}
        </Button>
      </Form>
    </div>
  );
};

export default Login;
